/* Harvest Wave attribution carry-over (houstonmerrill.com -> wavesofcourage.org)
   1. On every page load, lift ad click IDs + UTMs off the URL into sessionStorage.
   2. On any click to a wavesofcourage.org link, append whatever we have that the
      link doesn't already carry. Works for nav, CTAs, ticket cards, sponsor hero.
   gclid in the landing URL is what lets the Google tag on WOC set _gcl_aw there,
   so the purchase attributes to the ad click even though it started on this domain. */
(function () {
  var KEYS = ['gclid','gbraid','wbraid','dclid','fbclid','ttclid','msclkid',
              'utm_source','utm_medium','utm_campaign','utm_content','utm_term','ref'];
  var STORE = 'hw_attrib';
  var TARGET = /(^|\.)wavesofcourage\.org$/i;

  function load() { try { return JSON.parse(sessionStorage.getItem(STORE) || '{}') || {}; } catch (e) { return {}; } }
  function save(o) { try { sessionStorage.setItem(STORE, JSON.stringify(o)); } catch (e) {} }

  var have = load();
  try {
    var sp = new URLSearchParams(location.search), fresh = false;
    KEYS.forEach(function (k) { var v = sp.get(k); if (v) { have[k] = v; fresh = true; } });
    if (fresh) { have._t = Date.now(); save(have); }
  } catch (e) {}

  function decorate(a) {
    var href = a.getAttribute('href'); if (!href || href.charAt(0) === '#') return;
    var u; try { u = new URL(href, location.href); } catch (e) { return; }
    if (!TARGET.test(u.hostname)) return;
    var changed = false;
    KEYS.forEach(function (k) { if (have[k] && !u.searchParams.has(k)) { u.searchParams.set(k, have[k]); changed = true; } });
    if (changed) a.setAttribute('href', u.toString());
  }

  function all() { Array.prototype.forEach.call(document.querySelectorAll('a[href*="wavesofcourage.org"]'), decorate); }

  /* decorate at click time (catches hrefs rewritten by section JS) and once at load (for hover/copy) */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a) decorate(a);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();

  window.hwAttrib = function () { return Object.assign({}, have); };
})();
